import { Nullable } from '../../types/common'
import BaseComponent from '../base-component/base-component'
import CartDrawer from './cart-drawer'

class CartDrawerHeader extends BaseComponent {
  cartDrawer: Nullable<CartDrawer>

  constructor() {
    super()

    this.cartDrawer = this.closest('cart-drawer')
  }

  connectedCallback(): void {
    if (this.cartDrawer) {
      this.cartDrawer.subscribe(
        'update-nodes',
        this.handleCartDrawerFinishUpdate,
      )
    }
  }

  disconnectedCallback(): void {
    if (this.cartDrawer) {
      this.cartDrawer.unsubscribe(
        'update-nodes',
        this.handleCartDrawerFinishUpdate,
      )
    }
  }

  handleCartDrawerFinishUpdate = ({ node }): void => {
    this.updateByNode(node)
  }

  updateByNode(node: HTMLElement): void {
    const newItems = node.querySelector('cart-drawer-header')

    if (!newItems) {
      return
    }

    const clonedNewItems = newItems.cloneNode(true)

    this.replaceChildren(...clonedNewItems.childNodes)
  }
}

export default CartDrawerHeader
